"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Home;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const UserContext_1 = require("../contexts/UserContext");
const Screen_1 = __importDefault(require("../components/Screen"));
const cancelable_promise_1 = require("cancelable-promise");
const MyPayCard_1 = __importDefault(require("../partials/MyPayCard"));
const GreetingCard_1 = __importDefault(require("../partials/GreetingCard"));
const MyBenefitsCard_1 = __importDefault(require("../partials/MyBenefitsCard"));
const TimeAttendanceCard_1 = __importDefault(require("../partials/TimeAttendanceCard"));
const W2ReadyMessage_1 = __importDefault(require("../partials/W2ReadyMessage"));
const EnrollmentOpportunityMessage_1 = __importDefault(require("../partials/EnrollmentOpportunityMessage"));
const SingleSignOn_1 = require("../shared/SingleSignOn");
const OnboardingNotice_1 = __importDefault(require("../partials/OnboardingNotice"));
const AnnouncementsCard_1 = __importDefault(require("../partials/AnnouncementsCard"));
const BirthdaysCard_1 = __importStar(require("../partials/BirthdaysCard"));
const CompanyOnboardingNotice_1 = __importDefault(require("../partials/CompanyOnboardingNotice"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const MfaReminder_1 = __importDefault(require("./MfaReminder"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const MasonryList_1 = __importDefault(require("../components/MasonryList"));
const Tile_1 = __importDefault(require("../components/Tile"));
const Helper_1 = require("../Helper");
const Risk_1 = __importDefault(require("../api/Risk"));
const MaintenanceContext_1 = require("../contexts/MaintenanceContext");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const ExternalLinks_1 = __importDefault(require("../api/ExternalLinks"));
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const CompanySettings_1 = __importDefault(require("../api/CompanySettings"));
const faClipboard_1 = require("@fortawesome/pro-duotone-svg-icons/faClipboard");
const faAddressBook_1 = require("@fortawesome/pro-duotone-svg-icons/faAddressBook");
const faAward_1 = require("@fortawesome/pro-duotone-svg-icons/faAward");
const faLink_1 = require("@fortawesome/pro-duotone-svg-icons/faLink");
const faThumbtack_1 = require("@fortawesome/pro-duotone-svg-icons/faThumbtack");
const faUser_1 = require("@fortawesome/pro-duotone-svg-icons/faUser");
const faShield_1 = require("@fortawesome/pro-duotone-svg-icons/faShield");
const faClock_1 = require("@fortawesome/pro-duotone-svg-icons/faClock");
const faRectangleList_1 = require("@fortawesome/pro-duotone-svg-icons/faRectangleList");
const faChartLine_1 = require("@fortawesome/pro-duotone-svg-icons/faChartLine");
const faList_1 = require("@fortawesome/pro-duotone-svg-icons/faList");
const faDisplay_1 = require("@fortawesome/pro-duotone-svg-icons/faDisplay");
const faMoneyCheckDollar_1 = require("@fortawesome/pro-duotone-svg-icons/faMoneyCheckDollar");
const faChalkboardTeacher_1 = require("@fortawesome/pro-duotone-svg-icons/faChalkboardTeacher");
const faChartUser_1 = require("@fortawesome/pro-duotone-svg-icons/faChartUser");
const HomeContent = (props) => {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { maintenanceMode, maintenanceCheck } = (0, MaintenanceContext_1.useMaintenanceContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size, columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [permissions, setPermissions] = react_1.default.useState([]);
    const permissionsPromise = react_1.default.useRef(null);
    const limitedView = userContext.isFormer || userContext.isContractor;
    const [training] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'training'));
    const trainingDisabled = training == null || !training?.isEnabled;
    const [perfMgmt] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'performance-management'));
    const perfMgmtDisabled = perfMgmt == null || !perfMgmt?.isEnabled;
    const [orgChart] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'org-chart'));
    const [timeAndAttendance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'time-and-attendance'));
    const timeDisabled = timeAndAttendance == null || !timeAndAttendance?.isEnabled;
    const [riskAndCompliance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'wc-risk'));
    const riskAndComplianceDisabled = riskAndCompliance == null || !riskAndCompliance?.isEnabled;
    const tileColumns = size == 'sm' || size == 'md' ? 3 : 4;
    const tileGap = 6;
    const tileHeight = 96;
    const tileStyle = { height: tileHeight, minHeight: tileHeight };
    const lawPromise = react_1.default.useRef(null);
    const [lawLoading, setLawLoading] = react_1.default.useState(false);
    const linksPromise = react_1.default.useRef(null);
    const [tileSlots, setTileSlots] = react_1.default.useState([]);
    const [birthdayCardVisible, setBirthdayCardVisible] = react_1.default.useState(false);
    const birthdayPromise = react_1.default.useRef(null);
    const iconSet = [
        faClipboard_1.faClipboard,
        faAddressBook_1.faAddressBook,
        faAward_1.faAward,
        faLink_1.faLink,
        faThumbtack_1.faThumbtack,
        faUser_1.faUser,
        faShield_1.faShield,
        faClock_1.faClock,
        faRectangleList_1.faRectangleList,
        faChartLine_1.faChartLine,
        faList_1.faList,
        faDisplay_1.faDisplay,
        faMoneyCheckDollar_1.faMoneyCheckDollar,
        faChalkboardTeacher_1.faChalkboardTeacher,
        faChartUser_1.faChartUser
    ];
    react_1.default.useEffect(() => {
        const tiles = [
            (0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.info'), disabled: maintenanceMode !== "off" && maintenanceCheck, icon: Theme_1.ICONS.DuoTone.AddressCard, onPress: () => props.navigation.navigate('MyInformation'), style: tileStyle }, "info")
        ];
        if ((orgChart?.isEnabled || userContext.isAdmin) && !limitedView) {
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:screenTitles.orgChart'), icon: Theme_1.ICONS.DuoTone.ChartDiagram, onPress: () => props.navigation.navigate('OrgChart'), disabled: maintenanceMode !== "off" && maintenanceCheck, style: tileStyle }, "org-chart"));
        }
        if (!(limitedView || trainingDisabled)) {
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.training'), icon: Theme_1.ICONS.DuoTone.ChalkboardTeacher, cornerIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, onPress: handleTraining, style: tileStyle }, "training"));
        }
        if (!(limitedView || perfMgmtDisabled)) {
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.perfMgmt'), icon: Theme_1.ICONS.DuoTone.ChartUser, cornerIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, disabled: maintenanceMode !== "off" && maintenanceCheck, onPress: handlePerformanceManagement, style: tileStyle }, "performance-management"));
        }
        if (!limitedView) {
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.filesLinks'), icon: Theme_1.ICONS.DuoTone.FolderTree, onPress: () => props.navigation.navigate('Documents'), disabled: maintenanceMode !== "off" && maintenanceCheck, style: tileStyle }, "files-links"));
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.discounts'), icon: Theme_1.ICONS.DuoTone.Tags, onPress: () => props.navigation.navigate('EmployeeDiscounts'), style: tileStyle }, "discounts"));
            tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.laborLawPosters'), icon: Theme_1.ICONS.DuoTone.Memo, cornerIcon: Helper_1.Helper.isPlatformWeb ? undefined : Theme_1.ICONS.Regular.ArrowUpRightFromSquare, onPress: handleLaborLawPosters, disabled: lawLoading, style: tileStyle }, "labor-law-posters"));
        }
        if (!userContext?.isFormer) {
            linksPromise.current?.cancel();
            linksPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => {
                ExternalLinks_1.default.get(token).then((data) => {
                    data.forEach(link => {
                        tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: link.title, disabled: maintenanceMode !== "off" && maintenanceCheck && link.isTSSO, icon: iconSet.filter(icon => icon.iconName == link.icon)[0], cornerIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, onPress: () => handleLinkNavigation(link), style: tileStyle }, link.linkId));
                    });
                });
            }).catch((error) => {
                console.error(error);
            }));
            permissionsPromise.current?.cancel();
            permissionsPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken()
                .then((token) => MyProfile_1.default.getPermissions(token, userContext?.employee?.employeeId)))
                .then((data) => {
                setPermissions(data.permissions);
                if (!riskAndComplianceDisabled && !limitedView && data.permissions.includes('coi-access')) {
                    tiles.push((0, jsx_runtime_1.jsx)(Tile_1.default, { title: t('common:appmenus.certificateOfInsurance'), cornerIcon: Theme_1.ICONS.Regular.ArrowUpRightFromSquare, icon: Theme_1.ICONS.DuoTone.Certificate, onPress: handleCertificateOfInsurance, style: tileStyle }, "certificate-of-insurance"));
                }
            })
                .catch((error) => {
                console.error(error);
            });
            Promise.all([linksPromise.current, permissionsPromise.current]).catch((error) => {
                console.error(error);
            }).finally(() => {
                const totalTileSlots = Math.ceil(tiles.length / tileColumns) * tileColumns;
                const tileSlots = Array.from({ length: totalTileSlots }, (_, index) => tiles[index] ?? null);
                setTileSlots(tileSlots);
            });
        }
        else {
            const totalTileSlots = Math.ceil(tiles.length / tileColumns) * tileColumns;
            const tileSlots = Array.from({ length: totalTileSlots }, (_, index) => tiles[index] ?? null);
            setTileSlots(tileSlots);
        }
        return () => {
            permissionsPromise?.current?.cancel();
            linksPromise?.current?.cancel();
        };
    }, []);
    react_1.default.useEffect(() => {
        if (!limitedView && (0, BirthdaysCard_1.canViewBirthdays)(userContext)) {
            birthdayPromise.current?.cancel();
            birthdayPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => CompanySettings_1.default.getBirthdayCard(token))).then((setting) => {
                setBirthdayCardVisible(setting?.visible ?? true);
            }).catch(() => {
                setBirthdayCardVisible(true);
            });
        }
        else {
            setBirthdayCardVisible(false);
        }
        const bdaySub = react_native_1.DeviceEventEmitter.addListener('event.birthdayCardSettingUpdated', (value) => {
            if (typeof value === 'boolean') {
                setBirthdayCardVisible(value);
            }
        });
        return () => {
            birthdayPromise.current?.cancel();
            bdaySub.remove();
        };
    }, [userContext?.client?.id, limitedView, props.refreshKey]);
    const handleLinkNavigation = (link) => {
        if (!link.isTSSO) {
            FirebaseAnalytics_1.default.LogEvent("feature_used", {
                'feature': "External Links",
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId,
                'link': link.title,
                'linkId': link.linkId,
                'url': link.link
            });
            if (Helper_1.Helper.isPlatformWeb) {
                /* @ts-ignore */
                global.window.open(link.link, '_blank');
            }
            else {
                react_native_1.Linking.openURL(link.link);
            }
        }
        else {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'External Links - Prism TSSO',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId,
                'link': link.title,
                'linkId': link.linkId,
                'componentId': link.componentId
            });
            SingleSignOn_1.SingleSignOn.Perform({
                navigation: props.navigation,
                client: userContext?.client?.id,
                provider: 'prismfeature',
                additionalRouting: link.componentId,
                title: link.title,
            });
        }
    };
    const handleLaborLawPosters = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': "Labor Law Posters",
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        if (Helper_1.Helper.isPlatformWeb) {
            props.navigation.navigate('LaborLawPosters');
            return;
        }
        lawPromise.current?.cancel();
        setLawLoading(true);
        lawPromise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then(token => Risk_1.default.getLaborLawPosterUrl(token))).then(data => {
            if (data.url) {
                props.navigation.navigate('WebScreen', { uri: data.url, title: t('common:appmenus.laborLawPosters') });
            }
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            setLawLoading(false);
        });
    };
    const handleTraining = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Mineral Training SSO',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        SingleSignOn_1.SingleSignOn.Perform({
            navigation: props.navigation,
            client: userContext?.client?.id,
            provider: 'mineral',
            title: t('common:appmenus.training'),
            referer: "https://employee.nextep.com"
        });
    };
    const handlePerformanceManagement = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Prism SSO - Performance Management',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        SingleSignOn_1.SingleSignOn.Perform({
            navigation: props.navigation,
            client: userContext?.client?.id,
            provider: 'prismfeature',
            additionalRouting: 'TALENTMGT',
            title: t('common:appmenus.perfMgmt')
        });
    };
    const handleCertificateOfInsurance = () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'VioletBerri SSO',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        SingleSignOn_1.SingleSignOn.Perform({
            navigation: props.navigation,
            client: userContext?.client?.id,
            provider: 'violetberri',
            title: t('company:text.certificate')
        });
    };
    const cards = [
        maintenanceMode === "off" && (0, jsx_runtime_1.jsx)(W2ReadyMessage_1.default, { navigation: props.navigation }),
        (limitedView || maintenanceMode !== "off") ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : (0, jsx_runtime_1.jsx)(EnrollmentOpportunityMessage_1.default, { navigation: props.navigation }),
        columns == 3 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : undefined,
        limitedView ? undefined : (0, jsx_runtime_1.jsx)(AnnouncementsCard_1.default, { navigation: props.navigation }),
        columns == 3 || limitedView ? undefined : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}),
        (0, jsx_runtime_1.jsx)(MyPayCard_1.default, { navigation: props.navigation }),
        columns == 3 ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : undefined,
        (limitedView || timeDisabled) ? undefined : (0, jsx_runtime_1.jsx)(TimeAttendanceCard_1.default, { navigation: props.navigation }),
        (0, jsx_runtime_1.jsx)(MyBenefitsCard_1.default, { navigation: props.navigation }),
        (limitedView || timeDisabled) ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}) : undefined,
        (limitedView || !birthdayCardVisible) ? undefined : (0, jsx_runtime_1.jsx)(BirthdaysCard_1.default, { navigation: props.navigation, visible: birthdayCardVisible }),
        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { borderTopWidth: columns > 1 ? 0 : 1, borderColor: THEME.LightGray, backgroundColor: columns == 1 ? THEME.SoftGray : undefined, marginHorizontal: columns == 1 ? -12 : 0, paddingHorizontal: columns == 1 ? 12 : 0, marginTop: columns == 1 ? (limitedView ? 8 : 0) : 0 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                    paddingHorizontal: columns != 1 ? 16 - (tileGap / 2) : 0,
                    marginHorizontal: columns != 1 ? 0 : -3,
                    paddingTop: 12,
                    paddingBottom: size != 'sm' ? -tileGap : 4,
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'stretch'
                }, children: tileSlots.map((tile, index) => ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: `${100 / tileColumns}%`, paddingHorizontal: tileGap / 2, marginBottom: tileGap }, children: tile
                        ||
                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    borderRadius: 4,
                                    backgroundColor: THEME.UltraLightGray,
                                    width: '100%',
                                    flex: 1
                                } }) }, `home-tile-slot-${index}`))) }) })
    ];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? { marginHorizontal: 12, marginVertical: 8 } : { marginTop: 6, marginBottom: 12, marginHorizontal: 16 }, children: (0, jsx_runtime_1.jsx)(GreetingCard_1.default, { navigation: props.navigation }) }), maintenanceCheck && maintenanceMode !== "off" &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginHorizontal: columns === 1 ? 12 : 16, padding: 12, backgroundColor: THEME.Warning, borderRadius: 4, marginBottom: 12 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ScrewdriverWrench, color: THEME.WarningText, style: { marginLeft: 4 }, size: 24 }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginLeft: 12, flex: 1, flexWrap: Helper_1.Helper.isPlatformWeb ? 'wrap' : 'nowrap' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.WarningText, fontSize: 14, fontWeight: '500', marginBottom: 4, userSelect: 'none' }, children: t('common:text.maintenance') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.WarningText, fontSize: 12, userSelect: 'none' }, children: t('common:text.maintenanceDescription') })] })] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(MasonryList_1.default, { style: { marginHorizontal: columns == 1 ? 12 : 0 }, children: cards }) })] }, props.refreshKey), (0, jsx_runtime_1.jsx)(MfaReminder_1.default, { navigation: props.navigation })] }));
};
const OnboardingContent = (props) => {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { columns, twoPercentOfScreen } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [companyOnboardingFeature] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'company-onboarding'));
    const companyOnboardingDisabled = companyOnboardingFeature == null || !companyOnboardingFeature?.isEnabled;
    const companyOnboarding = ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (userContext.isAdmin && !companyOnboardingDisabled) &&
            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { flex: 1, maxWidth: 800 }, children: (0, jsx_runtime_1.jsx)(CompanyOnboardingNotice_1.default, { navigation: props.navigation }) }) }, "Company"));
    const employeeOnboarding = ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : { flex: 1, maxWidth: 800 }, children: (0, jsx_runtime_1.jsx)(OnboardingNotice_1.default, { navigation: props.navigation }) }, "Employee"));
    const onboarding = [companyOnboarding];
    userContext.isOnboarding ? onboarding.unshift(employeeOnboarding) : onboarding.push(employeeOnboarding);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: columns == 1 ? {} : {
                flexDirection: 'row',
                justifyContent: 'center',
                marginHorizontal: -twoPercentOfScreen
            }, children: onboarding }) }));
};
function Home(props) {
    const navigation = react_1.default.useContext(native_1.NavigationContext);
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const [refreshKey, setRefreshKey] = react_1.default.useState(0);
    const { columns } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(Screen_1.default, { onRefresh: () => setRefreshKey(Math.random()), cardAdjust: false, containerStyle: userContext.isOnboarding ? {} : { backgroundColor: columns > 1 ? null : THEME.White }, scrollStyle: { paddingTop: 3 }, children: userContext.isOnboarding
            &&
                (0, jsx_runtime_1.jsx)(OnboardingContent, { navigation: navigation, refreshKey: refreshKey })
            ||
                (0, jsx_runtime_1.jsx)(HomeContent, { navigation: navigation, refreshKey: refreshKey }) }));
}
